import moment from 'moment';

export const notPastDateValidator = {
  validate: (date: Date | string) => moment(date).startOf('day').isSameOrAfter(moment().startOf('day')),
};
